const SDK_SRC = '/vendor/BgsSdk.min.1.42.0.js'
let loadingPromise = null

export function loadVendorSdk() {
  if (window.redfinger) {
    return Promise.resolve(window.redfinger)
  }

  if (loadingPromise) {
    return loadingPromise
  }

  loadingPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector(`script[src="${SDK_SRC}"]`)

    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(window.redfinger), { once: true })
      existingScript.addEventListener('error', () => reject(new Error('BgsSdk 加载失败')), { once: true })
      return
    }

    const script = document.createElement('script')
    script.src = SDK_SRC
    script.async = true
    script.onload = () => resolve(window.redfinger)
    script.onerror = () => reject(new Error('BgsSdk 加载失败'))
    document.head.appendChild(script)
  })

  return loadingPromise
}
